<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col v-for="(report, index) in reports" :key="index" cols="6">
          <Report
            :header="report.header"
            :loading="report.loading"
            :api="report.api"
            :api-payload="report.apiPayload"
            @generate="event => handleClick(event)"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import Report from './Report.vue'
import { ReportsService } from '@/services'

export default {
  components: {
    Report
  },
  data() {
    return {
      reports: {
        deposits: {
          header: 'Einlieferung',
          loading: false,
          api: 'deposits',
          apiPayload: { SqlReportType: 1 }
        },
        accumulatedDeposits: {
          header: 'Kumulierte Einlieferung',
          loading: false,
          api: 'accumulatedDeposits',
          apiPayload: { SqlReportType: 3 }
        },
        invoiceCustomer: {
          header: 'Rechnungskunden',
          loading: false,
          api: 'invoiceCustomer',
          apiPayload: { SqlReportType: 0 }
        },
        accumulatedInvoiceCustomer: {
          header: 'Kumulierte Rechnungskunden',
          loading: false,
          api: 'accumulatedInvoiceCustomer',
          apiPayload: { SqlReportType: 2, OutputType: ['XML', 'CSV'] }
        }
        // aplXMLReport: {
        //   header: 'APL XML Report',
        //   loading: false,
        //   api: 'aplreport',
        //   apiPayload: { OutputType: ['XML', 'CSV']}
        // }
      }
    }
  },
  methods: {
    /**
     * Handle click event for generating reports.
     * @param {string} reportKey - The key of the report to generate.
     * @param {Object} event - The event object containing date and API payload.
     */
    handleClick(event) {
      const reportKey = Object.keys(this.reports).find(
        key => this.reports[key].api === event.api
      )

      if (!reportKey) {
        console.error('Reportkey ungültig:', event)
        return
      }

      this.reports[reportKey].loading = true

      const payload = {
        startDate: event.dateFrom,
        endDate: event.dateTo,
        isXml: event.isXml,
        ...event.apiPayload
      }

      ReportsService[event.api](payload)
        .then(response => {
          if (
            (payload.isXml && response.contentType === 'application/xml')
          ) {
            const { file, contentType, filename } = response

            // base64 → binary → Blob
            const byteCharacters = atob(file)
            const byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            const byteArray = new Uint8Array(byteNumbers)
            const blob = new Blob([byteArray], { type: contentType })

            // URL erzeugen
            const url = URL.createObjectURL(blob)

            // Link erstellen & klicken
            const link = document.createElement('a')
            link.href = url
            link.download = filename || 'datei.xml'
            document.body.appendChild(link)
            link.click()

            // Aufräumen
            document.body.removeChild(link)
            URL.revokeObjectURL(url)
          } else {
            // fallback CSV
            const a = document.createElement('a')
            a.href = 'data:text/csv;base64,' + response.file
            a.download = `Tam-${event.api} ${event.dateFrom}-${event.dateTo}.csv`
            a.click()
          }
        })
        .catch(err => console.error(err))
        .finally(() => {
          this.reports[reportKey].loading = false
        })
    }
  }
}
</script>
